// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { dreyerxMainnet as _dreyerxMainnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the dreyerxMainnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 23451
 * Chain Name: DreyerX Mainnet
 * Default Block Explorer: https://scan.dreyerx.com
 * Default RPC URL: https://rpc.dreyerx.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { dreyerxMainnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: dreyerxMainnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const dreyerxMainnet = createCommon({
	..._dreyerxMainnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
